import { identity } from "lodash-es";

import { PhoneNumber } from "@/data/phones/types";

export const formatPhone = (phone?: PhoneNumber | null) => {
  if (!phone || !phone.phoneNumber) {
    return "";
  }

  const { phoneNumber, phonePrefix } = phone;

  return [phonePrefix, phoneNumber].filter(identity).join(" ");
};
